import React, { useEffect } from "react";
import Head from "next/head";
import { handleIsAuthenticated } from "../utils/utils";
import { handleLoginPageViewedEvent } from "../utils/helperEventFunctions";
import { useSelector } from "react-redux";
import TAGS from "../public/headJson.json";
import LoginComponent from "../components/LoginComponent";
import withNoAuth from "../HOC's/withNoAuth";

const Login = (props) => {
  const { webviewEvent, source_screen } = props;
  const firebase_uid = useSelector((state) => state.currentUser?.firebaseUID);

  useEffect(() => {
    if (!handleIsAuthenticated()) {
      handleLoginPageViewedEvent({
        firebase_uid,
        source_screen,
        webviewEvent,
      });
    }
  }, []);

  return (
    <div>
      <Head>
        <title>{TAGS.login.title}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <LoginComponent />
    </div>
  );
};

export default withNoAuth(Login);
